import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {IPaymentType} from "../../../../../../../utils/interfaces/my_documents/fiscal_registry/payment/IPaymentType";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";


const useApiGetPaymentType = (pk: number | undefined): UseQueryResult<IPaymentType, CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(company_token: string | undefined, pk: number | undefined): Promise<IPaymentType> {
        try {
            const response = await get(`/api/company/${company_token}/my_documents/payment/payment_type/${pk}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetPaymentType", pk],
        queryFn: () => doGet(selectedCompany?.company_token, pk),
        enabled: !!pk
    })
};

export default useApiGetPaymentType